<template>
	<modal
		:id="ref"
		:ref="ref"
		:closeProp="close"
		:title="'Anagrafica: ' + datas['nome'] + ' ' + datas['cognome']"
		:id_donor="'id_donor'"
	>
		<!--
			<div v-for="(v, k) in datas" :key="k">
			<div v-if="k != 'actions'">
				<span>{{ k }} -> {{ v }}</span>
			</div>
		</div>
		<span>---------------------------</span>
		<span> {{ datas }}</span>
		<span>---------------------------</span>
		<span>{{ fixDatasToPrint }}</span>
		<span>----------------------------------------------------</span>-->

		<!--<div v-for="(value, key) in fixDatasToPrint" :key="key">
			<div style="margin-bottom: 25px">
				<span style="color:#616161;text-align:center;">{{ key }}</span>
				<span style="color:red;text-align:center;">{{ value }}</span>
			</div>
		</div>-->

		<div class="row">
			<div
				v-for="(value, key) in fixDatasToPrint"
				:key="key"
				class="col-4"
				style="margin-bottom: 25px"
			>
				<p style="color: #616161; font-size: 13px">{{ key.toUpperCase() }}</p>
				<span v-if="value != null" style="color: black; font-size: 1rem">{{ value }}</span>
				<span v-else style="color: lightslategray; font-size: 1rem; font-style: italic"
					>Nessun valore</span
				>
			</div>
		</div>
	</modal>
</template>

<script>
export default {
	data: () => ({
		ref: 'donors_modal',
		refForm: '',
		urlupdate: '',
		id: '',
		datas: {},
	}),
	props: {
		reftable: {
			type: String,
			default: '',
			required: false,
		},
	},

	computed: {
		fixDatasToPrint: function () {
			let new_datas = {
				ID: this.datas['id'],
				Modalità: this.datas['sandbox'] == 1 ? 'Test' : 'Live',
				'Codice Socio': this.datas['codice_area_soci'],
				'Data raccolta': this.datas['data_raccolta_display'],
				'Ragione sociale': this.datas['ragione_sociale'],
				Nome: this.datas['nome'],
				Cognome: this.datas['cognome'],
				Genere: this.datas['genere'],
				'Codice fiscale': this.datas['codice_fiscale'],
				'Data di nascita': this.datas['data_nascita_display'],
				'Luogo di nascita': this.datas['luogo_nascita'],
				'Partita IVA': this.datas['partita_iva'],
				'E-mail 1': this.datas['email1'],
				'E-mail 2': this.datas['email2'],
				'Telefono 1': this.datas['telefono1'],
				'Telefono 2': this.datas['telefono2'],
				'Cellulare 1': this.datas['cellulare1'],
				'Cellulare 2': this.datas['cellulare2'],
				Presso: this.datas['presso'],
				Indirizzo: this.datas['address'],
				/*Dug: this.datas['dug'],
				Duf: this.datas['duf'],
				Civico: this.datas['civico'],
				'Altro civico': this.datas['altro_civico'],*/
				Località: this.datas['localita'],
				Provincia: this.datas['provincia'],
				Cap: this.datas['cap'],
				'Codice nazione': this.datas['codice_nazione'],
				'Codice web': this.datas['codice_web'],
				Altro: this.format_json(this.datas['other']),
			}
			return new_datas
		},
	},

	created: function () {
		this.refForm = this.ref + 'DataForm'
	},

	methods: {
		close: function () {
			this.assignData({})
			this.urlupdate = ''

			this.$refs[this.ref].close()
		},
		open: function (data) {
			if (!!data && typeof data === 'object') {
				if (!!data.urlupdate) this.urlupdate = data.urlupdate
				if (!!data.datas) this.assignData(data.datas)
			} else if (!!data && Array.isArray(data)) {
				this.assignData(data)
			} else {
				this.assignData({})
			}

			this.$refs[this.ref].open()
			//console.log(Object.keys(this.datas))
			for (const key in this.datas) {
				console.log(`${key} -> ${this.datas[key]} ; `)
			}
		},

		//Prende i valori della riga
		getValue: function (key, defaultValue) {
			if (key === '') return this.datas
			else if (!!this.datas[key]) return this.datas[key]
			else if (this.datas[key] === 0 || this.datas[key] === '0' || this.datas[key] === false)
				return this.datas[key]
			else if (!!defaultValue) return defaultValue
			else return ''
		},

		assignData: function (datas) {
			if (!datas) return false

			if (!!Object.keys(datas).length) {
				this.datas = datas
				if (!!datas.id) this.id = datas.id
			} else {
				this.datas = {}
				this.id = ''
			}
		},

		format_json: function (data) {
			var s = ''
			for (var key in data) {
				var value = data[key]
				s = s + key.toUpperCase() + ': ' + value + ', '
			}

			return s.slice(0, -2)
		},
	},
}
</script>
